import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';
import ConsultorioPage from '../../Components/Consultorio-Page/Consultorio';

function Consultorio() {
    return (
        <>
            <div id="ConsultorioMain">
                <ConsultorioPage />
            </div>
            <div id="Agendamento">
                <Agendamento/>
            </div>
           <div id="Footer">
                <Footer />
            </div>
        </>
    );
}

export default Consultorio;